import React from 'react';

export default class EquationAnswerFeedback extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if(this.props.visible){
      if(this.props.equationAnswerCorrect){
        return (
          <div className="inequality-feedback">
            <p className="inequality-feedback__correct">
              You are correct!
            </p>
          </div>
        );
      }
      else {
        return (
          <div className="inequality-feedback">
            <p>
              <span className="inequality-feedback__incorrect">
                Sorry...
              </span>
              that answer is incorrect. Try again!
            </p>
          </div>
        );
      }
    }
    else {
      return (
        <div className="inequality-feedback"></div>
      );
    }
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/algebra/equation_answer_feedback.js
 **/